<ion-item button class="divider ion-text-wrap" [detail]="true" (click)="gotoBlock()">
    <ion-label>
        <h2>{{ title | translate }}</h2>
    </ion-label>
</ion-item>
